<template>
  <div>
    <div class="content">
      <span class="update">更新内容</span>
      <span class="date">{{ item.release_at }}</span>
      <div class="note" ref="content">
        <pre>{{ item.note }}</pre>
      </div>
      <el-link
          v-if="isOverflow"
          class="more"
          :underline="false"
          v-on:click="dialogVisible=true"
      >
        更多
      </el-link>
    </div>
    <el-dialog
        :title="item.name"
        :visible.sync="dialogVisible"
        width="60%"
        class="dialog"
    >
      <span slot="title">
        <DialogTitle :item="item"/>
      </span>
      <DialogBody :item="item"/>
      <span slot="footer">
        <DialogFooter :item="item"/>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DialogTitle from "@/views/detail/DialogTitle";
import DialogFooter from "@/views/detail/DialogFooter";
import DialogBody from "@/views/detail/DialogBody";

export default {
  name: 'ItemContext',
  components: {DialogBody, DialogFooter, DialogTitle},
  data() {
    return {
      isOverflow: false,
      dialogVisible: false,
    }
  },
  props: {
    item: {}
  },
  methods: {
    getIsOverflow() {
      const el = this.$refs.content;
      this.isOverflow = el.clientHeight < el.scrollHeight;
    }
  },
  mounted() {
    this.getIsOverflow()
  },
}
</script>

<style lang="scss" scoped>
.content {
  margin: 17px 16px;

  .update {
    height: 20px;
    font-size: 14px;
    color: #666666;
  }

  .date {
    margin-left: 6px;
    height: 17px;
    font-size: 12px;
    color: #666666;
  }

  .note {
    margin-top: 2px;
    overflow: hidden;
    height: 120px;
  }

  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 12px;
    color: #666666;
    line-height: 21px;
    text-align: left;
  }

  .more {
    height: 17px;
    font-size: 12px;
    color: #265CFD;
    margin-left: 10px;
  }
}

@media (min-width: 375px) {
  .info-w {
    width: 259px;
  }

  /deep/ .el-dialog {
    width: 100% !important;
  }
}

@media (min-width: 608px) {
  .info-w {
    width: 204px;
  }

  /deep/ .el-dialog {
    max-width: 60%;
  }
}


/deep/ .el-dialog {
  border-radius: 30px;
}

/deep/ .el-dialog__body {
  padding: 10px 40px;
}

///deep/ .el-dialog__header {
//  padding: 24px 20px 24px 24px;
//  box-shadow: inset 0 -1px 0 0 #DDDDDD;
//}

</style>
